export class ScintillationMetricModel {
  ag!: string[];
  d!: number;
  hr!: string;
  singleHr!: string;
  map!: Nullable<string>;
  rg!: number;
  val!: StringOrNumber;
  ver!: string;
  gmc!: number;
}

export default class ScintillationMetric extends ScintillationMetricModel {
  val: string;

  constructor({ ag, d, hr, singleHr, map, rg, val, ver, gmc }: ScintillationMetricModel) {
    super();

    this.ag = ag;
    this.d = d;
    this.hr = hr;
    this.singleHr = singleHr;
    this.map = map;
    this.rg = rg;
    this.val = (val as number).toFixed(2);
    this.ver = ver;
    this.gmc = gmc;
  }
}
